
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGeofence } from "@interfaces/IGeofences";
import { IGoogleMapsMarkerOptions } from "@interfaces/IGoogleMapsMarkerOptions";
import { GoogleMarkerService, ICreateEventMarkerOptions, MarkerAnchorPosition } from "@services/googleMarker.service";
import { IMarkerEvents } from "@typings/google.maps.angular";
import * as angular from "angular";
import { IOnChangesObject } from "angular";
import { CoordsModel } from "../../../../main/components/livemap/model/CoordsModel";
import { IGeofenceNavigationPoint } from "../geofences.interfaces";
import "./geofenceNavPoints.component.scss";

interface IGeofenceMapMarker {
    id: number;
    geofence: IGeofence
    navigationPoint?: IGeofenceNavigationPoint;
    coords: CoordsModel;
    options?: IGoogleMapsMarkerOptions;
}

export class GeofenceNavPointsComponentController implements angular.IComponentController {

    // bindings
    navigationPoints: IGeofenceNavigationPoint[] = [];
    enableEdit: boolean = false;
    onNavPointPositionChanged: (args: { navigationPoint: IGeofenceNavigationPoint, position: google.maps.LatLng }) => void;

    veriMap: IVeriMapComponent;
    map: google.maps.Map;

    navigationPointMarkers: IGeofenceMapMarker[] = [];
    navigationPointMarkerEvents: IMarkerEvents<IGeofenceMapMarker> = {
        dragend: (marker: google.maps.Marker, eventName: string, model: IGeofenceMapMarker, mouseEvent: any) => {
            this.onNavigationPointMarkerDragEnd(marker, eventName, model, mouseEvent);
        }
    }

    static $inject = ["googleMarkerService"];

    constructor(private readonly googleMarkerService: GoogleMarkerService) {
    }

    $onInit() {
        this.veriMap.mapInitialisedPromise.then(map => {
            this.map = map;

            this.updateMarkers();
        });
    }

    $onChanges(onChangesObj: IOnChangesObject): void {
        if (!this.veriMap.mapInitialised) {
            return;
        }

        if (onChangesObj["navigationPoints"] || onChangesObj["enableEdit"]) {
            this.updateMarkers();
        }
    }

    private updateMarkers(): void {
        this.clearCurrentMarkers();
        this.addMarkersForNavigationPoints(this.navigationPoints);
    }

    private clearCurrentMarkers(): void {
        this.navigationPointMarkers = [];
    }

    private addMarkersForNavigationPoints(navigationPoints: IGeofenceNavigationPoint[]): void {
        if (!navigationPoints?.length || navigationPoints?.length <= 0) {
            return;
        }

        const newMarkers: IGeofenceMapMarker[] = [];

        navigationPoints?.forEach((navigationPoint, index) => {
            navigationPoint.coords = new CoordsModel(navigationPoint.Latitude, navigationPoint.Longitude);
            newMarkers.push(this.createMapMarkerForNavigationPoint(navigationPoint, index, `${navigationPoint?.Name}`, `pin_drop`, `#ff6e40`));
        });

        this.navigationPointMarkers = [...newMarkers];
    }

    private createMapMarkerForNavigationPoint(navigationPoint: IGeofenceNavigationPoint, id: number, label: string, icon: string, color: string): IGeofenceMapMarker {
        if (!navigationPoint?.Latitude || !navigationPoint?.Longitude || !icon) {
            return;
        }

        const markerOptions: ICreateEventMarkerOptions = {
            label: label,
            subIcon: icon,
            showLabel: true,
            anchorPosition: MarkerAnchorPosition.Top,
            colour: color
        };

        const eventMarkerOptions: IGoogleMapsMarkerOptions = this.googleMarkerService.createEventMarkerOptions(markerOptions);
        eventMarkerOptions.draggable = this.enableEdit;
        eventMarkerOptions.position = {
            lat: navigationPoint.Latitude,
            lng: navigationPoint.Longitude
        };

        const locationCoords: CoordsModel = new CoordsModel(navigationPoint.Latitude, navigationPoint.Longitude);

        const marker: IGeofenceMapMarker = {
            id: id,
            geofence: null,
            navigationPoint: navigationPoint,
            coords: locationCoords,
            options: eventMarkerOptions
        };

        return marker;
    }

    private onNavigationPointMarkerDragEnd(marker: google.maps.Marker, eventName: string, model: IGeofenceMapMarker, mouseEvent: MouseEvent): void {
        const newPosition = marker?.getPosition();

        if (!model?.navigationPoint || !newPosition) {
            return;
        }

        if (this.onNavPointPositionChanged) {
            this.onNavPointPositionChanged({ navigationPoint: model?.navigationPoint, position: marker?.getPosition() });
        }
    }
}

export class GeofenceNavPointsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            navigationPoints: "<",
            enableEdit: "<",
            onNavPointPositionChanged: "&"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = GeofenceNavPointsComponentController;
        this.template = require("./geofenceNavPoints.component.html");
    }
}
